import { CheckoutReason } from '~features/annals';
import { detectIfBannerCtaClicked } from '~features/newsBanner/utils/retention-popup-url-parser';

export const getPaywallReason = (fallback: CheckoutReason) => {
	if (detectIfBannerCtaClicked()) {
		return CheckoutReason.RetentionPopupCTA;
	}
	return fallback;
};
